import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, Fragment as _Fragment } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputSelect = _resolveComponent("InputSelect")!
  const _component_InputSelect2 = _resolveComponent("InputSelect2")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    ($props.isAvailableShow)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass($props.ufClass)
        }, [
          _createVNode(_component_InputSelect, {
            label: `${$props.ufLabel}:`,
            name: "uf",
            modelValue: $setup.uf,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.uf) = $event)),
            onChange: $setup.onChangeCarregarMunicipios,
            placeholder: "Selecione uma das opções",
            required: $props.required,
            options: $setup.stateList,
            disabled: $props.disableMod
          }, null, 8 /* PROPS */, ["label", "modelValue", "required", "options", "disabled"])
        ], 2 /* CLASS */))
      : _createCommentVNode("v-if", true),
    ($props.isAvailableShow && $props.showMunicipio)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: _normalizeClass($props.municipioClass)
        }, [
          ($props.municipioName)
            ? (_openBlock(), _createBlock(_component_InputSelect2, {
                key: 0,
                label: `${$props.municipioLabel}:`,
                name: "municipio_id",
                modelValue: $setup.municipio,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.municipio) = $event)),
                disabled: ($props.isFilter && !$setup.municipios.length) || $props.disableMod,
                onChange: _cache[2] || (_cache[2] = ($event: any) => ($setup.onChange())),
                placeholder: "Selecione uma das opções",
                required: $props.requiredMunicipio !== undefined ? $props.requiredMunicipio : $props.required,
                options: $setup.municipios
              }, null, 8 /* PROPS */, ["label", "modelValue", "disabled", "required", "options"]))
            : (_openBlock(), _createBlock(_component_InputSelect, {
                key: 1,
                label: `${$props.municipioLabel}:`,
                name: "municipio_id",
                modelValue: $setup.municipio,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.municipio) = $event)),
                disabled: ($props.isFilter && !$setup.municipios.length) || $props.disableMod,
                onChange: _cache[4] || (_cache[4] = ($event: any) => ($setup.onChange())),
                placeholder: "Selecione uma das opções",
                required: $props.requiredMunicipio !== undefined ? $props.requiredMunicipio : $props.required,
                options: $setup.municipios
              }, null, 8 /* PROPS */, ["label", "modelValue", "disabled", "required", "options"]))
        ], 2 /* CLASS */))
      : _createCommentVNode("v-if", true)
  ], 64 /* STABLE_FRAGMENT */))
}